import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Heading } from '@grandvisionhq/elements';

const StorePaymentMethods = (_param)=> {
    var { className , labels , items  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "items"
    ]);
    return React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-payment-methods-stores-v2', className)
    }), /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        component: "h3"
    }, labels.title), /*#__PURE__*/ React.createElement("ul", {
        className: "store-payment-methods-stores-v2__items"
    }, items.map(({ name , iconUrl  })=>/*#__PURE__*/ React.createElement("li", {
            key: name,
            className: "store-payment-methods-stores-v2__item"
        }, /*#__PURE__*/ React.createElement("img", {
            className: "store-payment-methods-stores-v2__icon",
            alt: name,
            src: iconUrl
        }), name)
    )));
};

export { StorePaymentMethods as default };
//# sourceMappingURL=StorePaymentMethods.js.map
